<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Registracija Tuš klub spletnega profila</h1>
        <split-content text="Imate Tuš klub kartico?" />
        <empty-space />
        <v-alert
                :value="invalid_no_selection"
                type="warning"
        >
            Za nadaljevanje izberite eno izmed možnosti.
        </v-alert>
        <empty-space v-if="invalid_no_selection" />
        <image-option-selector2 v-model="selected_option" option1="Imam Tuš klub kartico" :option1_image="require('../assets/existing-card.png')" option2="Nimam Tuš klub kartice"  :option2_image="require('../assets/new-card.png')" />
        <empty-space />
        <v-btn depressed large block color="primary_action" @click="goNext">POTRDI</v-btn>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";
    import ImageOptionSelector2 from "../components/ImageOptionSelector2";
    import Router from '../router';
    import utils from "../store/utils";

    export default {
        name: "CreateAccountSelect",
        components: {MainContentWrapper, SplitContent, ImageOptionSelector2, EmptySpace},
        data: vm => ({
            invalid_no_selection: false,
            selected_option: undefined
        }),
        computed: {
            authenticated: utils.vuexBuildSetGet(this, 'auth', 'authenticated'),
            authenticated_user: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user'),
        },
        watch: {
            authenticated: function(){
                this.checkAccess()
            }
        },
        created(){
            let canDo = this.$store.state.application.allow_join_club;
            if (!canDo){
                if (this.$store.state.application.allow_upgrade_to_club &&
                    this.$store.state.auth.authenticated_user.can_upgrade_join &&
                    this.$store.state.application.flow_data.request_type == 'UPG_JOIN'){
                    canDo = true;
                }
            }
            if (!canDo){
                Router.push('/ustvari/');
            }
        },
        mounted() {
            this.$trackPageVisit('create-account-select');
        },
        methods: {
            checkAccess(){
                if (this.authenticated && this.authenticated_user.connected_account_is_temp == false) {
                    Router.push('/racun');
                }
            },
            goNext(){
                if (this.selected_option == '1'){
                    this.invalid_no_selection = false;
                    if (this.authenticated) {
                        Router.push('/racun/povezi');
                    } else {
                        Router.push('/ustvari/');
                    }
                } else if (this.selected_option == '2'){
                    this.invalid_no_selection = false;
                    this.$store.dispatch('registration/goToStep', 1);
                } else {
                    this.invalid_no_selection = true;
                }
            }
        }
    }
</script>

<style scoped>

</style>